export default __webpack_public_path__ + "static/product-2-7d46d9466b0b6ea8afacbcc55a7e3006.jpg";